/**
 * Store status popup (spec 0101 / ADR-073).
 * Cooldown via localStorage: não reabre por N minutos após exibir/fechar.
 */
(() => {
  const STORAGE_KEY = 'gm-store-status-popup-until';
  const MS_MIN = 60 * 1000;

  /**
   * @param {number} minutes
   */
  function setCooldown(minutes) {
    try {
      const until = Date.now() + Math.max(0, minutes) * MS_MIN;
      localStorage.setItem(STORAGE_KEY, String(until));
    } catch {
      /* private mode / blocked */
    }
  }

  /**
   * @returns {boolean}
   */
  function isInCooldown() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const until = Number(raw);
      if (!Number.isFinite(until)) return false;
      if (Date.now() < until) return true;
      localStorage.removeItem(STORAGE_KEY);
      return false;
    } catch {
      return false;
    }
  }

  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    const dialog = /** @type {HTMLDialogElement | null} */ (
      root.querySelector('[data-gm-store-status-popup-dialog]')
    );
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const cooldownMinutes = Math.max(
      0,
      Number(root.dataset.cooldownMinutes) || 5,
    );
    const closeBtns = root.querySelectorAll('[data-gm-store-status-popup-close]');

    const close = () => {
      setCooldown(cooldownMinutes);
      if (dialog.open) dialog.close();
    };

    const open = () => {
      if (dialog.open) return;
      try {
        dialog.showModal();
      } catch {
        /* already open / not connected */
      }
      setCooldown(cooldownMinutes);
      const focusTarget =
        /** @type {HTMLElement | null} */ (
          root.querySelector('.gm-store-status-popup__btn')
        ) ||
        /** @type {HTMLElement | null} */ (
          root.querySelector('[data-gm-store-status-popup-close]')
        );
      focusTarget?.focus?.();
    };

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        close();
      });
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    if (isInCooldown()) return;
    open();
  }

  const boot = () => {
    document
      .querySelectorAll('[data-gm-store-status-popup]')
      .forEach((node) => {
        if (node instanceof HTMLElement) init(node);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
